import type { User, WorkspaceMember, WorkspaceRole } from "./types";

export function workspaceRoleForUser(
  workspaceMembers: WorkspaceMember[],
  workspaceId: string,
  userId: string | null
): WorkspaceRole | null {
  if (!workspaceId || !userId) return null;
  return (
    workspaceMembers.find(
      (member) => member.workspaceId === workspaceId && member.userId === userId
    )?.role ?? null
  );
}

export function roleCanWrite(role: WorkspaceRole | null): boolean {
  return role === "owner" || role === "admin" || role === "member" || role === "bot";
}

export function roleCanAdmin(role: WorkspaceRole | null): boolean {
  return role === "owner" || role === "admin";
}

/**
 * Profiles are intentionally readable across every workspace two people
 * share, so historical authors still render. Assignment controls are stricter:
 * only current members of the active workspace are valid choices.
 */
export function usersForWorkspace(
  users: User[],
  workspaceMembers: WorkspaceMember[],
  workspaceId: string
): User[] {
  if (!workspaceId) return [];
  const memberIds = new Set(
    workspaceMembers
      .filter((member) => member.workspaceId === workspaceId)
      .map((member) => member.userId)
  );
  return users.filter((user) => memberIds.has(user.id));
}
